import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import withOptions from 'utils/functions/withOptions.util';

import { CLIENTS_SMSTEXT_FAILURE, CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS } from './beGetClientSmsText.types';

const beGetClientSmsText = withOptions(({ salonId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
}));

export default beGetClientSmsText;
